import { Dispatch } from 'redux';
import {
  getData, postData, putData,
} from '.';
import {
  GET_MY_LEAVES,
  GET_MANAGEMENT_LEAVES,
  LEAVE_ERROR,
  LEAVE_LOADING,
  POST_LEAVE,
  PATCH_LEAVE,
  CANCEL_LEAVE,
  SET_TOAST,
} from './types';

export const getMyLeavesAction = async (dispatch: Dispatch) => {
  const url = '/leave/me';
  dispatch({
    type: LEAVE_LOADING,
    payload: GET_MY_LEAVES,
  });
  const response: any = await getData(LEAVE_ERROR, url, dispatch, true);
  if (response?.data?.leaves) {
    dispatch({
      type: GET_MY_LEAVES,
      payload: response.data.leaves,
    });
  }
};

export const createLeaveAction = async (dispatch: Dispatch, data: any) => {
  const url = '/leave';
  dispatch({
    type: LEAVE_LOADING,
    payload: POST_LEAVE,
  });
  const response: any = await postData(LEAVE_ERROR, url, dispatch, data, true);
  if (response?.data?.leave) {
    dispatch({
      type: POST_LEAVE,
      payload: response.data.leave,
    });
    dispatch({
      type: SET_TOAST,
      payload: {
        message: 'La demande de congés a été créée',
        type: 'success',
      },
    });
  }
  return response;
};

export const getManagementLeavesAction = async (
  dispatch: Dispatch,
  structure?: string | null,
) => {
  let url = '/leave';
  if (structure) {
    url += `?structure=${structure}`;
  }
  dispatch({
    type: LEAVE_LOADING,
    payload: GET_MANAGEMENT_LEAVES,
  });
  const response: any = await getData(LEAVE_ERROR, url, dispatch, true);
  if (response?.data?.leaves) {
    dispatch({
      type: GET_MANAGEMENT_LEAVES,
      payload: response.data.leaves,
    });
  }
};

export const patchLeaveAction = async (
  dispatch: Dispatch,
  id: string,
  body: Record<string, unknown>,
) => {
  const url = `/leave/${id}`;
  dispatch({
    type: LEAVE_LOADING,
    payload: PATCH_LEAVE,
  });
  const response: any = await putData(LEAVE_ERROR, url, dispatch, body, true);
  if (response?.data?.leave) {
    dispatch({
      type: PATCH_LEAVE,
      payload: response.data.leave,
    });
    dispatch({
      type: SET_TOAST,
      payload: {
        message: 'Demande mise à jour',
        type: 'success',
      },
    });
  }
  return response;
};

export const cancelLeaveAction = async (dispatch: Dispatch, id: string) => {
  const url = `/leave/${id}/cancel`;
  dispatch({
    type: LEAVE_LOADING,
    payload: CANCEL_LEAVE,
  });
  const response: any = await putData(LEAVE_ERROR, url, dispatch, {}, true);
  if (response?.data?.leave) {
    dispatch({
      type: CANCEL_LEAVE,
      payload: response.data.leave,
    });
    dispatch({
      type: SET_TOAST,
      payload: {
        message: 'La demande de congés a été annulée',
        type: 'success',
      },
    });
  }
  return response;
};
